import React, { useEffect } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import LoginPageForm from './components/LoginPage/LoginPageForm/LoginPageForm';
import PasswordResetForm from './components/PasswordResetPage/PasswordResetForm/PasswordResetForm';
import SetNewPasswordForm from './components/SetNewPassword/SetNewPasswordForm';
import InvalidResetPasswordPage from './components/SetNewPassword/InvalidResetPasswordPage';
import LoginWrapForm from './components/LoginWrapForm/LoginWrapForm';
import ReactGA from 'Shared/analytics';
import moment from 'moment';

const LoginPage = () => {
  const { path } = useRouteMatch();

  useEffect(() => {
    ReactGA.pageview(path, 'LoginPage');
  }, [path]);

  return (
    <div className="app">
      <div className="login-page">
        <Switch>
          <Route path={`${path}/reset/confirm/:uuid/:resetToken/`}>
            <LoginWrapForm>
              <SetNewPasswordForm />
            </LoginWrapForm>
          </Route>
          <Route path={`${path}/reset/`}>
            <LoginWrapForm>
              <PasswordResetForm />
            </LoginWrapForm>
          </Route>
          <Route path={`${path}/error`}>
            <InvalidResetPasswordPage />
          </Route>
          <Route path={path}>
            <LoginWrapForm>
              <LoginPageForm />
            </LoginWrapForm>
          </Route>
        </Switch>
        <span className="login-page__copyright">© Copyright {moment().format('YYYY')} AnvilEight LTD</span>
      </div>
    </div>
  );
};

export default LoginPage;
